import { Module } from '@nestjs/common';
import { CertificationsController } from './certifications.controller';
import { CertificationsService } from './certifications.service';
import { Certifications } from './certifications.entity';
import { CertificationAdapter } from './dto/certifications.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports: [
    TypeOrmModule.forFeature([Certifications]),
  ],
  controllers: [CertificationsController],
  providers: [CertificationsService, CertificationAdapter, ApplicationExceptionHandler,LogsService],
  exports: [CertificationsService]
})
export class CertificationsModule {}
